module.exports = __webpack_public_path__ + "a9b425d409a8cf92486ed3619e81372f.svg";